import React, { useContext, useEffect, useState } from "react";
import { getApolloContext } from "@apollo/react-hooks";
import AWSAppSyncClient from "aws-appsync";
import { Spinner } from "components";

const Rehydrated = ({ children }) => {
  const { client } = useContext(getApolloContext());
  const [rehydrated, setState] = useState(false);

  useEffect(() => {
    if (client instanceof AWSAppSyncClient) {
      (async () => {
        await client.hydrated();
        setState(true);
      })();
    }
  }, [client]);
  return rehydrated ? <>{children}</> : <Spinner />;
};

export default Rehydrated;
